import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-medium transition-all duration-300 overflow-hidden rounded-none';
  const variants = {
    primary: 'bg-brand-purple text-white hover:bg-brand-dark border border-brand-purple hover:border-brand-dark shadow-[0_0_15px_rgba(74,14,78,0.3)] hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]',
    secondary: 'bg-brand-gold text-brand-dark hover:bg-yellow-500 border border-brand-gold',
    outline: 'bg-transparent text-brand-purple border-2 border-brand-purple hover:bg-brand-purple hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-3 text-base tracking-wide',
    lg: 'px-10 py-4 text-lg tracking-wider'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={twMerge(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-99">
      <span className="relative z-10 flex items-center gap-2" data-id="element-100">{children}</span>
      {variant === 'primary' && <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent hover:animate-[shimmer_1.5s_infinite]" data-id="element-101" />}
    </motion.button>;
}